const titleBase = {
  color: "primary.main",
  textTransform: "capitalize",
  fontWeight: "medium",
  alignSelf: "flex-start",
};

export const styles = {
  resetPasswordContainer: {
    width: "100%",
    boxSizing: "border-box",
    alignItems: "center",
  },
  contentBox: {
    width: "100%",
    boxSizing: "border-box",
    minWidth: "17rem",
    maxWidth: "27rem",
    px: 2,
    gap: "2rem",
  },
  title: {
    ...titleBase,
    fontSize: 20,
  },
  subtitle: {
    ...titleBase,
    fontSize: 16,
  },
};
